var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "199", height: "96", viewBox: "0 0 199 96", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "Symbols", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "Read-Receipt-rate-card---iOS", transform: "translate(-24)" },
        React.createElement(
          "g",
          { id: "Group", transform: "translate(24)" },
          React.createElement("path", { d: "M44.222 0h110.556C179.2 0 199 19.103 199 42.667v10.666C199 76.897 179.201 96 154.778 96H7.37C3.3 96 0 92.816 0 88.889V42.667C0 19.103 19.799 0 44.222 0z", id: "Rectangle-Copy", fill: "#34F", fillRule: "nonzero" }),
          React.createElement("path", { d: "M38 0h123c20.987 0 38 17.013 38 38v20c0 20.987-17.013 38-38 38H4a4 4 0 0 1-4-4V38C0 17.013 17.013 0 38 0z", id: "Rectangle", fill: "#34F" }),
          React.createElement(
            "g",
            { id: "Group-4", transform: "translate(26 27)", fill: "#0000BF" },
            React.createElement("rect", { id: "Rectangle", width: "143", height: "10", rx: "5" }),
            React.createElement("rect", { id: "Rectangle", y: "18", width: "117", height: "10", rx: "5" }),
            React.createElement("rect", { id: "Rectangle", y: "36", width: "129", height: "10", rx: "5" })
          )
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/ReadReceiptRateCard/svgs/big_bubble.svg